import Repo from './Repo.js'

export default class ElectricityConstantRepository extends Repo {
  constructor () {
    super('electricity-constants')
  }

  all (q) {
      return super.all(q)
  }

  update (id, data) {
      return super.update(id, data)
  }

  get (id) {
      return super.get(id)
  }

  paginate (q) {
      return super.paginate(q)
  }
}
